import * as NavigationMenuPrimitive from '@radix-ui/react-navigation-menu'
import React from 'react'

import { styled } from '~/styled'
import { preventEvent } from '~/utilities/event/preventEvent'

const StyledContent = styled(NavigationMenuPrimitive.Content, {
  base: ['p-3', 'bg-(--dropdown-background)', 'mt-1', 'shadow-md', 'rounded-md']
})

type NavigationMenuDropdownContentProps = React.ComponentProps<
  typeof StyledContent
>

export const NavigationMenuDropdownContent = ({
  children,
  ...rest
}: NavigationMenuDropdownContentProps) => (
  <StyledContent
    onPointerMove={preventEvent}
    onPointerLeave={preventEvent}
    {...rest}
  >
    <ul>{children}</ul>
  </StyledContent>
)

NavigationMenuDropdownContent.displayName = 'NavigationMenuDropdownContent'
